import {type SelectOptionItem, Button, Grid, List, Select} from '@yandex-delivery/blocks'
import {get} from '@yandex-delivery/utils'
import {useState} from 'react'
import {Controller, useFormContext} from 'react-hook-form'

import type {PickupStation} from '../../../api/address/model/types'
import * as classes from './PointSelect.classes'
import type {PointSelectProps as Props} from './PointSelect.types'
import {PvzIcon} from './PvzIcon'

export function PointSelect(props: Props): React.ReactElement {
  const {
    name, //
    options = [],
    placeholder,
    trailButtonCaption,
    isPending = false,
  } = props
  const {control} = useFormContext()
  const [opened, setOpened] = useState(false)

  return (
    <Controller
      control={control}
      name={name}
      render={({field, fieldState}) => (
        <>
          <Select<PickupStation>
            className={classes.select}
            disabled={options.length === 0}
            error={fieldState.invalid}
            filter={filter}
            helperText={fieldState.error?.message}
            isPending={isPending}
            makeKey={makeKey}
            name={name}
            onChange={(item: SelectOptionItem<PickupStation> | null) => {
              field.onChange(item?.value)
            }}
            options={options}
            placeholder={placeholder}
            portal={false}
            renderOptionText={renderItem}
            trail={
              <Button
                className={classes.button}
                disabled={options.length === 0}
                loading={isPending}
                onPress={() => {
                  setOpened(true)
                }}
                shape="circle"
                size="xs"
                variant="outline"
              >
                {trailButtonCaption}
              </Button>
            }
            value={field.value}
            hideToggleIcon
          />
          {opened && <div>PointsByCityModal component here...</div>}
        </>
      )}
    />
  )
}

const makeKey: (o: SelectOptionItem<PickupStation>) => string = get('value.id')

function renderItem(item: SelectOptionItem<PickupStation>) {
  return (
    <Grid alignItems="center" size="s" wrap="nowrap" container>
      <Grid item>
        <PvzIcon />
      </Grid>
      <Grid size="s" container item xs>
        <Grid item xs>
          <List.Label variant="body2">
            <span className={classes.label}>{item.label}</span>
          </List.Label>
          <List.Description color="minor" variant="caption1">
            {item.value.name}
          </List.Description>
        </Grid>
      </Grid>
    </Grid>
  )
}

function filter(textValue: string, inputValue: string) {
  return textValue.toLowerCase().includes(inputValue.toLowerCase())
}
